import { render, staticRenderFns } from "./admin-chart.vue?vue&type=template&id=a5fd1868&"
import script from "./admin-chart.vue?vue&type=script&lang=ts&"
export * from "./admin-chart.vue?vue&type=script&lang=ts&"
import style0 from "./admin-chart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports